import { useQuery } from '@tanstack/react-query';
import publicAxiosInstance from '../../../constants/publicAxiosInstance';

interface ValidateShareCodeData {
  isAccessible: boolean;
  message?: string;
}

interface ValidateShareCodeResponse {
  message?: string;
  data: ValidateShareCodeData;
}

interface ValidateShareCodeRequest {
  shortToken: string;
}

const validateShareCode = async (shortToken: string): Promise<ValidateShareCodeData> => {
  const { data } = await publicAxiosInstance().post<ValidateShareCodeResponse>(
    '/deeplinks/validateShareCode',
    { shortToken } as ValidateShareCodeRequest
  );
  return data?.data ?? { isAccessible: false, message: '' };
};

export const useValidateShareCode = (shortToken: string, enabled: boolean = true) => {
  const {
    data,
    isLoading: isValidating,
    error: validationError,
  } = useQuery<ValidateShareCodeData>({
    queryKey: ['validateShareCode', shortToken],
    queryFn: () => validateShareCode(shortToken),
    enabled: enabled && !!shortToken,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return {
    isAccessible: data?.isAccessible ?? false,
    isValidating,
    validationError,
    message: data?.message ?? '',
  };
};
